var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectsArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Projects_-_Arrow_",
    "data-name": "Projects - Arrow ",
    transform: "translate(-975 -146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2960",
    "data-name": "Rectangle 2960",
    transform: "translate(975 146)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Arrow_Arrow_Up_Right_MD",
    "data-name": "Arrow / Arrow_Up_Right_MD",
    transform: "translate(980 151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7,17,17,7m0,0H9m8,0v8",
    transform: "translate(-7 -7)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsArrow);
export default __webpack_public_path__ + "static/media/Projects - Arrow.c720aa82916669c5a23030054b7096f5.svg";
export { ForwardRef as ReactComponent };